import React, { FC } from 'react'
import { breakpoint, styled } from '@moonpig/launchpad-utils'
import { system as s } from '@moonpig/launchpad-system'
import { Flex } from '@moonpig/launchpad-components'
import { Message } from './Message'
import { STEP_SECONDS } from './constants'
import { buildScrollKeyframes } from './buildScrollKeyframes'

const Viewport = styled.div`
  ${s({
    overflow: 'hidden',
    height: '40px',
    borderTop: 1,
    borderBottom: 1,
    borderColor: 'colorBorder03',
    my: { xs: 4, md: 5 },
    mx: { xs: 6, md: 0 },
  })}

  ${breakpoint('md')} {
    height: auto;
    overflow: visible;
  }
`

const Duplicate = styled.div`
  ${breakpoint('md')} {
    display: none;
  }
  @media (prefers-reduced-motion: reduce) {
    display: none;
  }
`

const Track = styled(Flex)<{ count: number }>`
  justify-content: center;
  flex-direction: column;
  animation: ${({ count }) => buildScrollKeyframes(count)}
    ${({ count }) => count * STEP_SECONDS}s linear infinite;

  ${breakpoint('md')} {
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    animation: none;
    transform: none;
  }

  @media (prefers-reduced-motion: reduce) {
    animation: none;
    transform: none;
  }
`

export type InlineTickerMessagesProps = {
  messages: string[]
}

export const InlineTickerMessages: FC<InlineTickerMessagesProps> = ({
  messages,
}) => {
  return (
    <Viewport>
      <Track data-testid="inline-ticker-messages-track" count={messages.length}>
        {messages.map(message => (
          <Message key={message} message={message} />
        ))}
        <Duplicate aria-hidden>
          {messages.map(message => (
            <Message key={`${message}-duplicate`} message={message} />
          ))}
        </Duplicate>
      </Track>
    </Viewport>
  )
}
